const interestsData = {
  headings: {
    interests: "Interests",
  },
  groups: [
    ["Photography", "Playing cricket", "Economics", "Reading books"],
    ["Listening music", "Playing chess"],
  ],
};

export default interestsData;
